'use client';

import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';

import { BigCard } from './components/BigCard';
import { SmallCard } from './components/SmallCard';

import { devices } from '@/styles/breakpoints';

interface IProps {}

const Blog: FC<IProps> = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const getServerSideProps = async () => {
      try {
        const res = await fetch(
          'https://api-app.orcatec.com/api/v1.0/public/pages/blog?per_page=4&page=1',
          {
            headers: {
              referer: 'https://orcatec.com',
              //  'x-api-key': 'd6SlHdfwFoGjAJ5r8GptcUYr6zMX3Nfj',
            },
          }
        );
        if (!res.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await res.json();

        setData(data.data);
      } catch (error) {
        console.error('Error fetching data:', error);
        return { props: { title: '', subTitle: '', data: null } };
      }
    };
    getServerSideProps();
  }, []);

  const [big, ...rest] = data;

  return (
    <Wrapper>
      <ArticlesWrapper>
        {big && <BigCard type="blog" item={big} />}

        <ArticlesWrapperInner>
          {!!rest?.length &&
            rest?.map((item) => (
              <SmallCard type="blog" key={item.id} item={item} />
            ))}
        </ArticlesWrapperInner>
      </ArticlesWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div``;
const ArticlesWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  @media only screen and ${devices.desktop} {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 24px;
  }
`;

const ArticlesWrapperInner = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  row-gap: 16px;

  @media only screen and ${devices.desktop} {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 550px;
  }
`;

export default Blog;
